import styled from "styled-components";
import { Price } from "./Price";

export const DiscountPrice = styled(Price)<{
  fontSize?: string;
  fontWeight?: string;
  alignSelf?: string;
}>`
  color: ${({ theme }) => theme.text.secondary};
  text-decoration: line-through;
  line-height: 1.5;
  font-size: ${({ fontSize }) => (fontSize ? fontSize : "12px")};
  padding: 0 10px;
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : "500")};
  align-self: ${({ alignSelf }) => (alignSelf ? alignSelf : "center")};

  @media (min-width: 768px) {
    align-self: ${({ alignSelf }) => (alignSelf ? alignSelf : "center")};
    padding: 0 2px;
  }
`;
